/**
 * Product page: label the add-to-cart button "Pre-Order".
 *
 * A product is pre-order when it has the `btn_preorder` tag (`#preorder_tag`
 * has a value) or when the selected variant has `custom.pre_order` set (its
 * `.list_var_<id>` input has a value). Both inputs are rendered by
 * `snippets/product-details.liquid`.
 *
 * The compiled theme bundle resets the button text on every variant change.
 * After it has picked an existing variant it dispatches a non-bubbling
 * `change` on the product form; the capture listener below sees that event
 * and re-applies the label once the theme has finished updating the button.
 */
(function () {
  if (window.__skuPreorderLabel) return;
  window.__skuPreorderLabel = true;

  var PREORDER_TEXT = 'Pre-Order';

  function isPreorder(variantId) {
    var productFlag = document.getElementById('preorder_tag');
    if (productFlag && productFlag.value) return true;

    var variantFlag = variantId && document.querySelector('.list_var_' + variantId);
    return Boolean(variantFlag && variantFlag.value);
  }

  function applyLabel(variantId) {
    if (!isPreorder(variantId)) return;
    var labels = document.querySelectorAll('.btn_cst_atc span.text_atc');
    for (var i = 0; i < labels.length; i++) labels[i].textContent = PREORDER_TEXT;
  }

  var initialVariant = document.getElementById('current_var_load');
  applyLabel(initialVariant && initialVariant.value);

  document.addEventListener(
    'change',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-product-form]')) return;

      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput && idInput.value;
      setTimeout(function () {
        applyLabel(variantId);
      }, 0);
    },
    true
  );
})();
